import { EyeIcon, MonitorIcon, MoonIcon, SunIcon } from "lucide-react";
import { createAction, Priority, useRegisterActions } from "kbar";
import { useFocusMode } from "@/pages/ModelTool/hooks/useFocusMode";
import { useTheme } from "@/providers/ThemeProvider";

export default function useSystemActions() {
  const { setTheme } = useTheme();
  const [, setFocusMode] = useFocusMode();

  useRegisterActions(
    [
      createAction({
        name: "Set theme to light",
        keywords: "light mode theme",
        perform: () => setTheme("light"),
        priority: Priority.HIGH,
        section: "Preferences",
        icon: <SunIcon className="size-4" />,
      }),
      createAction({
        name: "Set theme to dark",
        keywords: "dark mode theme",
        perform: () => setTheme("dark"),
        priority: Priority.HIGH,
        section: "Preferences",
        icon: <MoonIcon className="size-4" />,
      }),
      createAction({
        name: "Set theme to system",
        keywords: "system auto mode theme",
        perform: () => setTheme("system"),
        priority: Priority.HIGH,
        section: "Preferences",
        icon: <MonitorIcon className="size-4" />,
      }),
      createAction({
        name: `Toggle focus mode`,
        keywords: "focus mode full screen",
        priority: Priority.HIGH,
        icon: <EyeIcon className="size-4" />,
        perform: () => {
          setFocusMode((prev) => !prev);
        },
        section: "Preferences",
      }),
    ],
    [setTheme, setFocusMode],
  );
}
